module.exports = __webpack_public_path__ + "static/media/image-black.0d43d8b8.svg";